import { defineStore } from 'pinia'
import { useStorage } from '@vueuse/core'
import { ref, computed } from 'vue'
// import SecureLS from 'secure-ls'

// const ls = new SecureLS({ encodingType: 'aes', isCompression: false, encryptionSecret: 'vcy6u05eq7Vi+MKssWx+Ly0Tm5lHAwjmwXTHDnMU/bI=' })
// const ls = new SecureLS({ isCompression: false })

export const stores = defineStore('appdachakolombiastore', () => {
  const colores = ref(null)
  const rules = ref(null)
  const user = ref(null)
  const token = ref({ id: 0, text: '' })
  const apiUrl = ref('')
  const prefix = ref('')
  const auth = ref(false)
  const expira = ref(null)
  const items = ref(null)
  const theme = ref(1)
  const dark = ref(false)

  const state = useStorage('appdachakolombia', { colores: colores.value, rules: rules.value, user: user.value, token: token.value, apiUrl: apiUrl.value, prefix: prefix.value, auth: auth.value, expira: expira.value, items: items.value, theme: theme.value, dark: dark.value })

  const getColores = computed(() => state.value.colores)
  const getRules = computed(() => state.value.rules)
  const getUser = computed(() => state.value.user === undefined ? null : state.value.user)
  const getToken = computed(() => state.value.token)
  const getUrlApi = computed(() => state.value.apiUrl + 'api/')
  const getStorage = computed(() => state.value.apiUrl + 'storage/')
  const getAuth = computed(() => state.value.auth)
  const getExpira = computed(() => state.value.expira)
  const getPrefix = computed(() => state.value.prefix + '/')
  const getDark = computed(() => state.value.dark)
  const getTheme = computed(() => state.value.theme)
  const getItems = computed(() => state.value.items)

  const setColores = (pValue) => {
    state.value.colores = pValue
  }

  const setRules = (pValue) => {
    state.value.rules = pValue
  }

  const setUser = (pValue) => {
    state.value.user = pValue
  }

  const setToken = (pValue) => {
    state.value.token.id = pValue.accessToken.id
    state.value.token.text = pValue.plainTextToken
  }

  const setUrlApi = (pValue) => {
    state.value.apiUrl = pValue
  }

  const setPrefix = (pValue) => {
    state.value.prefix = pValue
  }

  const setItems = (pValue) => {
    state.value.items = pValue
  }

  const setTheme = (pValue) => {
    state.value.theme = pValue
  }

  const setDark = (pValue) => {
    state.value.dark = pValue
  }

  return { user, theme, colores, getColores, getRules, getUser, getToken, getUrlApi, getStorage, getAuth, getExpira, getPrefix, getDark, getTheme, getItems, setUser, setToken, setUrlApi, setColores, setPrefix, setTheme, setRules, setItems, setDark }
})
